import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { OpeningGeometry } from "./OpeningGeometry";
export class Opening extends OpeningGeometry {
    constructor(pRoomManager, pOpening) {
        super(pRoomManager, pOpening);
        this.mOpening = pOpening;
        this.mOpeningParams = {};
        this.mOpeningParams.minWidth = 0.4;
        if (this.mOpening.OpeningParams !== null) {
            this.mOpening.OpeningParams.minWidth = this.mOpeningParams.minWidth;
        }
    }
    get canMirrorH() {
        return (false);
    }
    get canMirrorV() {
        return (false);
    }
    getType() {
        return ("Opening");
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.885;
        tParams.height = 2.01;
        tParams.floorOffset = 0.0;
        return (tParams);
    }
    create3dGeometry(pParent) {
        //invisible geometry for picking
        let tSelectionPlane = CreatePlane("", {
            width: this.mOpening.width,
            height: this.mOpening.height
        }, this.mScene);
        tSelectionPlane.position.y = this.mOpening.height * 0.5;
        tSelectionPlane.parent = pParent;
        if (this.mOpening.wall != null)
            tSelectionPlane.name = "room:wall|" + this.mOpening.wall.id.toString();
        tSelectionPlane.visibility = 0;
        this.prepare3dMesh(tSelectionPlane);
    }
    serializeIOData() {
        return (this.mOpening.OpeningParams);
    }
}
